import { apiClient } from '@/services/api';
import type { ApiResponse } from '@/types/auth';
import type { AdminDetailUser, AdminListUser, ListUsersParams, UserStats, UsersPagination } from '@/types/admin';

class AdminUserService {
  listUsers(params: ListUsersParams = {}) {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    if (params.status && params.status !== 'all') query.set('status', params.status);
    if (params.userType && params.userType !== 'all') query.set('userType', params.userType);

    const qs = query.toString();
    return apiClient.get<
      ApiResponse<{ users: AdminListUser[]; pagination: UsersPagination }>
    >(`/admins/users${qs ? `?${qs}` : ''}`);
  }

  getUserStats() {
    return apiClient.get<ApiResponse<{ stats: UserStats }>>('/admins/users/stats');
  }

  getUserById(id: number) {
    return apiClient.get<ApiResponse<{ user: AdminDetailUser }>>(`/admins/users/${id}`);
  }
}

export const adminUserService = new AdminUserService();
